export const openedSidebarWidth = '300px';
export const closedSidebarWidth = '56px';
export const headerSidebarDropDownHeight = '50px';
export const sidebarPadding = '16px';
export const sidebarContainerHeight = `calc(100vh - 50px)`;
